import React from 'react';

const articles = [
  {
    id: 1,
    image: '/images/keyword/1.jpg',
    title: 'Pune to Mumbai Cabs',
    description:
      "Skyline Cabs offers reliable, comfortable, and affordable cab services for your journey. Whether it’s a business trip, airport transfer, or a weekend getaway, our Pune to Mumbai cab service is designed to give you a smooth travel experience.",
    link: '/Pune-to-Mumbai-Cab'
  },
  {
    id: 2,
    image: '/images/keyword/2.jpg',
    title: 'Pune to Mumbai Airport Cab',
    description:
      "Need a reliable ride from Pune to Mumbai Airport? Skyline Cabs has got you covered. We specialize in door-to-door airport transfers from Pune to Chhatrapati Shivaji Maharaj International Airport (BOM), ensuring you reach your terminal on time and stress-free.",
    link: '/Pune-to-Mumbai-Airport-Cab'
  },
  {
    id: 3,
    image: '/images/keyword/29.jpg',
    title: 'Mumbai to Pune Cabs',
    description:
      "Looking for a reliable Mumbai to Pune cab service? Skyline Cabs offers seamless intercity travel with comfort, punctuality, and great pricing. Whether you're heading home, visiting friends, or traveling for work, we make your journey stress-free and comfortable.",
    link: '/Mumbai-to-Pune-Cabs'
  }
];

const TrendingArticles = () => {
  return (
    <section className="pt-0">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-xl-8 col-lg-9 col-md-11 col-sm-12">
            <div className="secHeading-wrap text-center mb-5">
              <h2>Trending & Popular Articles</h2>
              <p>
                Cicero famously orated against his political opponent Lucius Sergius Catilina.
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center g-4">
          {articles.map(({ id, image, title, description, link }) => (
            <div key={id} className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <div className="blogGrid-wrap d-flex flex-column h-100 p-2 bg-lightt border rounded">
                <div className="blogGrid-pics">
                  <a href={link} className="d-block">
                    <img src={image} className="img-fluid rounded" alt="Blog" />
                  </a>
                </div>
                <div className="blogGrid-caps pt-3">
                  <h4 className="fw-bold fs-6 lh-base">
                    <a href={link} className="text-dark">
                      {title}
                    </a>
                  </h4>
                  <p className="mb-3 text-white">{description}</p>
                  <div className="text-center">
                    <a className="read-more-btn  fw-medium" href={link}>
                      Read More <i className="fa-solid fa-arrow-trend-up ms-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrendingArticles;
